module.exports = __webpack_public_path__ + "img/vocational-rehabilitation-referral-front.0970d8ad.svg";